import { TYPE_SIGNATURE_FONTS } from './constants';

let readyPromise = null;

export const loadSignatureFonts = () => {
  if (typeof document === 'undefined' || !document.fonts?.load) return Promise.resolve();
  if (readyPromise) return readyPromise;

  readyPromise = import(/* webpackChunkName: "signature-fonts" */ './signatureFontStyles')
    .then(() =>
      Promise.all(
        TYPE_SIGNATURE_FONTS.filter((font) => font.googleFont).map((font) =>
          document.fonts.load(`32px "${font.googleFont}"`).catch(() => undefined)
        )
      )
    )
    .catch(() => undefined)
    .then(() => undefined);

  return readyPromise;
};
